import axios from "axios";
import { API_PATHS, LDG_PROGRAMME_NAME } from ".";

export const getUnauthedAxios = () =>
    axios.create({
        headers: {
            "Content-Type": "application/json",
        },
    })
export const getAxios = () => {
    const token = getToken();
    const headers = {
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
    }
    return axios.create({ headers });
}

export const getToken = () => {
    let accessToken = "";
    let token = localStorage.getItem("access_token");
    if (token) {
        let accessTokenObj = token.split("##");
        accessToken = accessTokenObj[0];
    }
    return accessToken;
};

export function getUrlSegment() {
    let url = window.location.pathname
    var segment = url.split("/");
    var filteredSegment = segment.filter(function (el) {
        return el != "";
    })
    return filteredSegment;
}

export function getCapitalized(string) {
    if (string) {
        let str = string.toUpperCase();
        return str;
    }
}

export const getCapital = (string) => {
    let str = "";

    if (string) {
        str = string.replace(
            /(^\w|\s\w)(\S*)/g,
            (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
        );
    }
    return str;
};

export const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
            resolve(
                (fileReader.result).replace(/^data:image\/\w+;base64,/, "")
            );
        };
        fileReader.onerror = (error) => {
            reject(error);
        };
    });
};

export const convertPDFBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
            resolve(
                (fileReader.result)
            );
        };
        fileReader.onerror = (error) => {
            reject(error);
        };
    });
};
export async function upLoadDocuments(data) {
    try {
        const result = await axios.post(`${API_PATHS.UPLOAD_API + "/" + 'token', data}`,)
        Promise.resolve(result)
    } catch (error) {
        Promise.reject(error)
    }
}

export function numberToWords(num) {
    const a = [
        '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
        'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'
    ];
    const b = [
        '', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'
    ];
    const c = [
        '', 'thousand', 'lakh', 'crore'
    ];

    if (num === 0) return 'zero';

    let words = '';

    function getBelowHundred(n) {
        if (n < 20) {
            return a[n];
        } else {
            return b[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + a[n % 10] : '');
        }
    }

    function getBelowThousand(n) {
        if (n < 100) {
            return getBelowHundred(n);
        } else {
            return a[Math.floor(n / 100)] + ' hundred' + (n % 100 !== 0 ? ' and ' + getBelowHundred(n % 100) : '');
        }
    }

    function getWordForSegment(n, index) {
        if (n === 0) return '';
        return getBelowThousand(n) + ' ' + c[index] + ' ';
    }

    let segments = [];
    let i = 0;

    // Segmenting number according to the Indian numbering system
    while (num > 0) {
        if (i === 1) { // For thousands place
            segments.push(num % 100);
            num = Math.floor(num / 100);
        } else {
            segments.push(num % 1000);
            num = Math.floor(num / 1000);
        }
        i++;
    }

    for (let j = segments.length - 1; j >= 0; j--) {
        if (segments[j] > 0) {
            words += getWordForSegment(segments[j], j);
        }
    }

    return words.trim();
}

// Returns an object { minMonths, maxMonths } or null if input is empty/invalid
export const parseExperienceRange = (range) => {
  if (range == null) return null;
  range = String(range).trim();

  if (!range) return null;

  const lower = range.toLowerCase();

  // Normalize multiple spaces, remove commas
  const normalized = lower.replace(/,/g, "").replace(/\s+/g, " ").trim();

  // "no experience" (allow trailing space etc.)
  if (/^no experience$/.test(normalized)) {
    return { minMonths: 0, maxMonths: 0 };
  }

  // "above 10 years", "more than 10 years", "10+ years"
  const aboveMatch = normalized.match(/(above|more than)\s*(\d+)|(\d+)\s*\+/);
  if (aboveMatch) {
    const years = parseInt(aboveMatch[2] || aboveMatch[3], 10);
    if (!isNaN(years)) {
      return { minMonths: years * 12, maxMonths: Infinity };
    }
  }

  // Range like "2-4 years" or "0 - 2 years"
  const rangeMatch = normalized.match(/(\d+)\s*-\s*(\d+)/);
  if (rangeMatch) {
    const low = parseInt(rangeMatch[1], 10);
    const high = parseInt(rangeMatch[2], 10);
    if (!isNaN(low) && !isNaN(high)) {
      return { minMonths: low * 12, maxMonths: high * 12 };
    }
  }

  // Single number "5 years" or "5 year"
  const singleMatch = normalized.match(/^\s*(\d+)\s*(year|years)?\s*$/);
  if (singleMatch) {
    const years = parseInt(singleMatch[1], 10);
    if (!isNaN(years)) {
      return { minMonths: years * 12, maxMonths: years * 12 };
    }
  }

  // fallback: extract all numbers and if there's at least one, use the last number as max
  const nums = normalized.match(/\d+/g);
  if (nums && nums.length >= 1) {
    const last = parseInt(nums[nums.length - 1], 10);
    if (!isNaN(last)) {
      return { minMonths: 0, maxMonths: last * 12 };
    }
  }

  // Unknown format
  return null;
};

// Backwards-compatible helper: returns maxMonths (number or Infinity) or null
export const getMaxMonthsFromRange = (range) => {
  const parsed = parseExperienceRange(range);
  if (!parsed) return null;
  return parsed.maxMonths;
};

// Returns true if valid, otherwise return a string with an error message
export const validateRelevantExperience = (totalExpRange, relevantMonths) => {
  const parsed = parseExperienceRange(totalExpRange);
  const relevant = parseInt(relevantMonths, 10);

  if (!parsed || isNaN(relevant)) {
    // If we can't parse the range or the entered months, skip strict validation
    return true;
  }

  const { minMonths, maxMonths } = parsed;

  // If min is 0 and max is 0 => "No experience" selected
  if (minMonths === 0 && maxMonths === 0) {
    if (relevant > 0) {
      return `The total experience you entered does not match the experience range selected. Please review and correct the values to proceed.`;
    }
    return true;
  }

  if (relevant < minMonths) {
    // For open-ended ranges like "Above 10 years", maxMonths === Infinity and minMonths is e.g. 120
    const minYears = Math.round(minMonths / 12);
    return `The total experience you entered does not match the experience range selected. Please review and correct the values to proceed.`;
  }

  if (maxMonths !== Infinity && relevant > maxMonths) {
    const maxYears = Math.round(maxMonths / 12);
    return `The total experience you entered does not match the experience range selected. Please review and correct the values to proceed.`;
  }

  return true;
};

// Hardened parsing for your exact FAMINCOME strings
export function parseIncomeRange(range) {
  if (!range && range !== 0) return { min: null, max: null };

  // Accept either string or object like {Id, value}
  let s = typeof range === "string" ? range : (range.value || range.Id || "");
  s = s.toString().trim().toLowerCase();

  // remove non-breaking spaces and normalize multiple spaces
  s = s.replace(/\u00A0/g, " ").replace(/\s+/g, " ").trim();

  // Less than X (e.g. "less than 2 lakhs")
  let m = s.match(/less\s*(?:than|than\s*or\s*equal\s*to|or\s*equal\s*to)\s*([0-9.]+)/i);
  if (m) {
    return { min: 0, max: parseFloat(m[1]) };
  }

  // Above X (e.g. "above 40 lakhs")
  m = s.match(/(?:above|greater\s*than|more\s*than)\s*([0-9.]+)/i);
  if (m) {
    return { min: parseFloat(m[1]), max: Infinity };
  }

  // Range: "X to Y" or "X.Y Lakhs to A.B Lakhs" or "X - Y"
  m = s.match(/([0-9]+(?:\.[0-9]+)?)\s*(?:lakh|lakhs)?\s*(?:to|-)\s*([0-9]+(?:\.[0-9]+)?)/i);
  if (m) {
    return { min: parseFloat(m[1]), max: parseFloat(m[2]) };
  }

  // As fallback, if the string contains a single number, treat as max with min=0
  m = s.match(/([0-9]+(?:\.[0-9]+)?)/);
  if (m) {
    return { min: 0, max: parseFloat(m[1]) };
  }

  return { min: null, max: null };
}

// Normalize input to monthly LAKHS
export function normalizeToLakhs(inputStr) {
  if (inputStr === null || inputStr === undefined) return NaN;

  let s = inputStr.toString().trim().toLowerCase();

  // remove ₹, commas, non-breaking spaces
  s = s.replace(/₹|,|\u00A0/g, "").trim();

  // remove 'per month', '/month', 'pm' tokens if present
  s = s.replace(/(\/month|per\s*month|\bpm\b)/i, "").trim();

  // if explicitly contains 'lakh' treat number as lakhs (monthly)
  if (s.includes("lakh")) {
    const n = parseFloat(s.replace(/[^\d.-]/g, ""));
    return isNaN(n) ? NaN : n;
  }

  // otherwise treat as rupees -> convert to lakhs
  const rupees = parseFloat(s.replace(/[^\d.-]/g, ""));
  if (isNaN(rupees)) return NaN;

  return rupees / 100000; // monthly value in lakhs
}

// Validate: rangeValue can be string or {Id,value}, userMonthlyIncome is monthly (₹ or number)
export function validateAnnualIncome(rangeValue, userMonthlyIncome) {
  const { min, max } = parseIncomeRange(rangeValue || "");
  const monthlyLakhs = normalizeToLakhs(userMonthlyIncome);

  if (isNaN(monthlyLakhs)) {
    return "Please enter a valid number.";
  }

  // convert monthly → annual in LAKHS
  const annualLakhs = monthlyLakhs * 12;

  // ensure parsing succeeded
  if (min === null || max === null) {
    return "Income range parsing error. Please contact support.";
  }

  // inclusive checks (>= min, <= max)
  if (annualLakhs < min) {
    return `The monthly income entered does not match with the annual income range chosen. Please verify your income details to proceed`;
  }

  if (max !== Infinity && annualLakhs > max) {
    return `The monthly income entered does not match with the annual income range chosen. Please verify your income details to proceed`;
  }

  return true;
}

export const isLDGProgramme = (...values) => {
  const targets = [
    LDG_PROGRAMME_NAME.toLowerCase(),
    "pg diploma in local development governance",
  ];
  return values.some((val) => {
    if (!val) return false;
    const texts = [];
    if (typeof val === "string") {
      texts.push(val.toLowerCase());
    } else {
      if (val.label) texts.push(String(val.label).toLowerCase());
      if (val.value) texts.push(String(val.value).toLowerCase());
    }
    return texts.some((text) =>
      targets.some((target) => text.includes(target))
    );
  });
};

export const getSopFileDetails = (source) => {
  if (!source) return null;

  const sopFile = source.sopFile || source.sopDocument || source.sopDocFile;
  if (!sopFile) return null;

  // Resolve the display title — prefer explicit title/Title,
  // fall back to filename extracted from PathOnClient
  const pathName = sopFile.PathOnClient
    ? sopFile.PathOnClient.replace(/^\//, "")
    : "";

  const title =
    sopFile.title ||
    sopFile.Title ||
    sopFile.label ||
    sopFile.fileName ||
    pathName ||
    "";

  const fileName = sopFile.fileName || pathName || title;
  const label = sopFile.label || sopFile.Title || sopFile.title || title;
  const link = sopFile.downloadUrl || sopFile.link || "";

  // Salesforce Chatter/ContentVersion identifiers (optional)
  const contentDocumentId = sopFile.contentDocumentId || "";
  const contentVersionId = sopFile.contentVersionId || "";

  // Base64 VersionData — present in the preview API response
  const versionData = sopFile.VersionData || sopFile.versionData || "";

  if (!title && !fileName && !label && !link && !versionData) return null;

  return {
    fileName,
    label,
    title,
    link,
    contentDocumentId,
    contentVersionId,
    versionData,
  };
};
